module.exports = __webpack_public_path__ + "img/prioritas_bosspack_cod_dg_k.ec3976dc.png";